module.exports = __webpack_public_path__ + "img/swap.daf142e2.svg";